export default function parseTextEditorValue() {
    return document.querySelector(".CodeMirror")?.innerText.replace(/•/g, "")
}
